import React, { useEffect, useState } from "react";
import { t } from "../i18n";

export function WelcomeTour({
  steps,
  currentStep,
  onNext,
  onPrev,
  onSkip,
  onFinish,
  tourRefs,
}) {
  const currentStepData = steps[currentStep];
  const [tooltipPosition, setTooltipPosition] = useState({
    top: 80,
    left: "50%",
    transform: "translateX(-50%)",
  });

  // Обновляем позицию tooltip при изменении шага
  useEffect(() => {
    if (!currentStepData) return;
    const updateTooltipPosition = () => {
      const isMobile = window.innerWidth <= 768;

      // На мобильных — центрируем tooltip как модальное окно (навигация в dropdown)
      if (isMobile) {
        setTooltipPosition({
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        });
        return;
      }

      const currentElement = tourRefs[currentStepData.id]?.current;
      if (currentElement) {
        const rect = currentElement.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        let position = {
          top: rect.bottom + 20,
          left: rect.left + rect.width / 2,
          transform: "translateX(-50%)",
        };

        if (rect.left + 175 > viewportWidth) {
          position.left = viewportWidth - 175;
          position.transform = "none";
        }
        if (rect.left - 175 < 0) {
          position.left = 175;
          position.transform = "none";
        }
        if (rect.bottom + 200 > viewportHeight) {
          position.top = rect.top - 200;
        }

        setTooltipPosition(position);
      }
    };

    updateTooltipPosition();
    window.addEventListener("resize", updateTooltipPosition);

    return () => {
      window.removeEventListener("resize", updateTooltipPosition);
    };
  }, [currentStep, currentStepData?.id, tourRefs]);

  if (!currentStepData) return null;

  return (
    <>
      {/* Overlay */}
      <div className="welcome-tour-overlay" />

      {/* Tooltip */}
      <div
        className="welcome-tour-tooltip"
        style={{
          top: tooltipPosition.top,
          left: tooltipPosition.left,
          transform: tooltipPosition.transform,
        }}
      >
        <div className="welcome-tour-title">{currentStepData.title}</div>
        <div className="welcome-tour-description">{currentStepData.description}</div>
        <div className="welcome-tour-progress">
          {t("Step")} {currentStep + 1} {t("of")} {steps.length}
        </div>
        <div className="welcome-tour-buttons">
          <div>
            {currentStep > 0 && (
              <button className="welcome-tour-button secondary" onClick={onPrev}>
                {t("Previous")}
              </button>
            )}
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            <button className="welcome-tour-button skip" onClick={onSkip}>
              {t("Skip Tour")}
            </button>
            <button
              className="welcome-tour-button primary"
              onClick={currentStep === steps.length - 1 ? onFinish : onNext}
            >
              {currentStep === 0
                ? t("Start")
                : currentStep === steps.length - 1
                  ? t("Start working")
                  : t("Next")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

